'use strict';

import { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import Alert from '@components/Widgets/Alert/Alert.react';
import { calculateYieldWarnings } from '@utils/YieldWarnings';
import '@pro/components/Modals/Modals.scss';

export default class WarningsModal extends Component {
    static propTypes = {
        isOpen: PropTypes.bool.isRequired,
        closeModal: PropTypes.func.isRequired,
        // Pre-computed warnings from generateWarningsFromDishServings (Primary modal)
        warnings: PropTypes.array,
        // Legacy props for calculateYieldWarnings fallback (Secondary modal scaling mode)
        dishes: PropTypes.array,
        contents: PropTypes.object,
        participants: PropTypes.array,
        extraServings: PropTypes.number
    };

    static defaultProps = {
        extraServings: 0
    };

    renderYieldWarnings = () => {
        const { warnings: precomputedWarnings, dishes, contents, participants, extraServings } = this.props;

        // Use pre-computed warnings if provided (Primary modal with leftovers),
        // otherwise fall back to calculateYieldWarnings (Secondary modal scaling mode)
        const warnings = precomputedWarnings || calculateYieldWarnings(dishes, contents, participants, extraServings);

        if (warnings.length) {
            return (
                <Alert
                    type="warning"
                    description={
                        <>
                            <strong>Please note, the following recipes have been adjusted to meet minimum yield requirements:</strong>
                            <ul>
                                {warnings.map((warning, index) => (
                                    <li key={index}>{warning}</li>
                                ))}
                            </ul>
                        </>
                    }
                />
            );
        }

        return <span className="no-warnings">Nothing to see here.</span>;
    };

    render() {
        const { isOpen, closeModal } = this.props;

        return (
            <Modal
                isOpen={isOpen}
                onRequestClose={closeModal}
                closeModal={closeModal}
                className="el-modal el-modal3 el-modal3-centered"
                overlayClassName="el-modal-overlay"
                contentLabel="Warnings"
                closeTimeoutMS={250}
            >
                <div className="el-modal-container el-modal3-container">
                    <header className="modal-header">
                        <h2>Notes</h2>
                        <button onClick={closeModal} className="el-modal-close-x">
                            <i className="icon-close-x" />
                            <span className="assistive-text">Close Modal</span>
                        </button>
                    </header>

                    <div className="el-modal-body-container el-modal3-body-container">
                        {this.renderYieldWarnings()}
                    </div>

                    <footer>
                        <button className="el-modal-ok-btn" onClick={closeModal}>OK</button>
                    </footer>
                </div>
            </Modal>
        );
    }
}
